export default {
  doctorateStat: [],
  orgCountByTypeAndOrgAdmin: [],
  orgCountByRegionAndType: [],
  countByApplyDocResearcherRegion: [],
  countByApplyDocResearcherRegionOrg: [],
  countByDirection: [],
  countByApplyDocResearcherOrganizationDirection: [],
  appliedYearCount: [],
  userCount: [],
  applyDocStatistics: [],
  organizationOfDirection: [],
  appliedDocCountByOrganization: [],
  appliedDocCountByDirection: [],
}
